export const DISCOUNTS = {
  VALID: "30",
  INVALID: "",
  INTERNAL: "100",
  NONE: "0",
};
